import Service from 'core/service'

export class AuthService extends Service {
  login(params: UserLogin): Promise<any> {
    return this.post('/admin/login', params)
  }
  logout(params: { id_token: string }): Promise<any> {
    return this.post('/admin/logout', params)
  }
  adminForgotPassword(params: UserForgot): Promise<any> {
    return this.post('/admin/forgot-password', params)
  }
  forgotPassword(params: UserForgot): Promise<any> {
    return this.post('/forgot-password', params)
  }
  resetPassword(params: UserReset): Promise<any> {
    return this.post('/reset-password', params)
  }
  loginWithEndUserCredential(params: UserLogin): Promise<any> {
    return this.post('/auth', params)
  }
  getAccessToken(params: GetAccessToken): Promise<any> {
    return this.post('/auth/token', params)
  }
  verifyToken(params: { token: string }): Promise<any> {
    return this.post('/auth/verify-token', params)
  }
}
